import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useIQSidePanelStore = defineStore("iqSidePanel", () => {
  const isOpen = ref(false);

  const isSidePanelOpen = computed(() => isOpen.value);

  const openSidePanel = () => {
    isOpen.value = true;
  };

  const closeSidePanel = () => {
    isOpen.value = false;
  };

  return {
    isOpen,
    isSidePanelOpen,
    openSidePanel,
    closeSidePanel,
  };
});
